module.exports = __webpack_public_path__ + "img/onBreak.dad3bf7f.png";